import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_AttributeTypeRow, WB_EntityRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Entity} from "../PA.Core/PAdbSchema";



const vWB_Attribute_Type_Fields:  {[id:string]: ISearchProviderField } = {
    WB_ATTRIBUTEM_ID:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'AttributeType WB Id',       columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
    ATTRIBUTEM_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Attribute Id',      columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    ATTRIBUTEM_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Attribute Name',    columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    SALESAREA_IND:            {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Sales Area Ind', columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    DATATYPE:                 {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Data Type',       columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    DISPLAYTYPE:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Display Type',        columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    TARGET_ENTITY_ID:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Target Entity Id',        columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    TARGET_ENTITY_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Target Entity Name',        columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

}

const vWB_AttributeType_KeyFields =
    {id:    'WB_ATTRIBUTEM_ID',
     id_ui: 'ATTRIBUTEM_ID',
     name:  'ATTRIBUTEM_NAME'}


class AttributeTypeSearchByListSearchProvider
    implements  ISearchProvider {

    arrWB_AttributeTypeRows:WB_AttributeTypeRow[] = []

    constructor(rows: WB_AttributeTypeRow[]){
        this.arrWB_AttributeTypeRows = rows
    }

    get keyFields() { return vWB_AttributeType_KeyFields }

    get searchProviderFields(){
        return vWB_Attribute_Type_Fields
    }

    async search(requestSpec: ISearchRequestSubset): Promise<any[]> {

        let dbContext = new PAdbContext()
        let arrWB_TargetEntities = _.filter(_.map(this.arrWB_AttributeTypeRows, (a) => a.cif.WB_ENTITY_ID_TARGET), (a) => a >0)
        let arrEntities = <WB_EntityRow[]> await dbContext.findUsingCache(esWB_Entity, arrWB_TargetEntities)
        let dct = _.keyBy(arrEntities, (a) => a.cif.WB_ENTITY_ID)

        return _.map(this.arrWB_AttributeTypeRows, (aAttrTypeRow: WB_AttributeTypeRow) => {
            let aRow: any = aAttrTypeRow.toJSON()
            let wbEntityId = aAttrTypeRow.cif.WB_ENTITY_ID_TARGET
            if(aAttrTypeRow.cif.DISPLAYTYPE == 'entity' ){
                aRow.TARGET_ENTITY_ID = dct[wbEntityId]?.cif?.ENTITY_ID || `Unknown Entity (${wbEntityId})`
                aRow.TARGET_ENTITY_NAME = dct[wbEntityId]?.cif?.ENTITY_NAME || `Unknown Entity (${wbEntityId})`
            } else {
                aRow.TARGET_ENTITY_ID = ''
                aRow.TARGET_ENTITY_NAME = ''
            }
            return aRow
        })
    }

}


class AttributeTypeSearchByListSearchProfile
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "AutoSearch Only"
    renderOptions = { ui5ResourceId: "AttributeTypeSearchByListProfile" }

    profileFilter: IProfileFilter[] = []

    profileDisplayFields = [
        'ATTRIBUTEM_NAME','ATTRIBUTEM_ID', 'DATATYPE', 'DISPLAYTYPE','TARGET_ENTITY_NAME'
    ]

    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor(WB_AttributeTypeRows: WB_AttributeTypeRow[]){
        this.aSearchProvider = new AttributeTypeSearchByListSearchProvider(WB_AttributeTypeRows)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class AttributeTypeSearchByList
    implements  ISearch {

    constructor(WB_AttributeTypeRows: WB_AttributeTypeRow[], options?: any){
        this.searchProfiles = [ new AttributeTypeSearchByListSearchProfile(WB_AttributeTypeRows) ]
    }

    searchName = "Select Attribute(s)"
    renderOptions = { ui5ResourceId: "AttributeTypeSearchByList"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
